import * as Immutable from 'immutable'

// eslint-disable-next-line import/prefer-default-export
export const ensureIsMutable = data => {
  if (Immutable.Iterable.isIterable(data)) {
    return data.toJS()
  }
  return data
}
